import React from 'react';
import RecommendedProductCard from './recommendedProdCard';
import { connect } from 'react-redux';
import ListAnimation from '../utils/animations/list';

const mapStateToProps = (state) => {
	const { productList } = state.rootReducer.buyCourse;
	const { isInternational } = state.rootReducer.loginDetails;
	return {
		productList,
		isInternational,
	};
};

const RecommendedProductList = ({ productList, isInternational }) => (
	<div className="">
		<h3 className="section-body-title">Recommended Courses</h3>

		<ListAnimation open={true} className="row">
			{typeof productList !== 'undefined'
				? Object.keys(productList).map((key) => {
						return key < 4 ? (
							<RecommendedProductCard
								key={productList[key].product_id}
								isInternational={isInternational}
								{...productList[key]}
							/>
						) : null;
				  })
				: null}
		</ListAnimation>
	</div>
);

export default connect(mapStateToProps)(RecommendedProductList);
